import React, { useState } from 'react';
import FaqItem from "./FaqItem"; 
const Questions = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'How do I sign up for the platform?',
      answer: 'To sign up for our platform, simply click on the "Sign Up" button at the top of the page.',
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We only accept bitcoin payment at the moment for more information "Contact us" at the top of the page or whatsapp us directly using the phone number +1(703)469-5762 or chat with us on the platform',
    },
    {
      question: 'How do I contact support?',
      answer: 'You can contact our 24/7 support team by visiting the "Contact Us" at the top of the page  or whatsapp us using the phone number +1(703)469-5762 or chat with us on the platform',
    },
	 {question: "How do i start investing ? ", 
		answer: "You simply start investing by making a deposit in your account our system will automatically start your investment "
	 }
  ];

  return (
    <div className="bg-gradient-to-b from-white to-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-extrabold text-center text-gray-900 mb-8 animate-fadeIn">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={activeIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Questions;

